import { getAnalytics } from "firebase/analytics";
import { initializeApp } from "firebase/app";
import {
	connectFunctionsEmulator,
	getFunctions,
	httpsCallable,
} from "firebase/functions";

import type { CDRRequest } from "./types/cdr-request.type";
import type { StripeCheckoutResponse } from "./types/response.type";

const firebaseConfig = {
	apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
	authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
	databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL,
	projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
	storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
	messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
	appId: import.meta.env.VITE_FIREBASE_APP_ID,
	measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
const functions = getFunctions(app, "europe-west1");

if (import.meta.env.USE_EMULATORS || import.meta.env.DEV) {
	connectFunctionsEmulator(functions, "127.0.0.1", 5001);
}

export const createStripeCheckout = httpsCallable<
	CDRRequest,
	StripeCheckoutResponse
>(functions, "createStripeCheckout");
